<template>
  <OnClickOutside @trigger="hideEmojiPicker" :options="{ ignore: [/* ... */] }">
    <button class="emoji-button" @click="toggleEmojiPicker">
      <img src="@/assets/emoji.svg" alt="emoji-toggle-button" />
    </button>
  </OnClickOutside>
</template>

<script>
import { emojisDefault, categoriesDefault, VEmojiPicker } from 'v-emoji-picker'
import tippy from 'tippy.js'
import { VueRenderer } from '@tiptap/vue-2'
import { OnClickOutside } from '@vueuse/components'

const excludedCategories = ['Flags']
const excludedEmojiAliases = ['poop', 'middle_finger', 'gun', 'bomb', 'knife', 'dagger', 'crossed_swords', 'smoking',
  'coffin', 'syringe', 'toilet', 'latin_cross', 'star_and_crescent', 'om', 'wheel_of_dharma', 'star_of_david',
  'six_pointed_star', 'menorah', 'yin_yang', 'orthodox_cross', 'place_of_worship', 'accept', 'radioactive',
  'biohazard', 'u6709', 'u7121', 'u7533', 'u55b6', 'u6708',
  'eight_pointed_black_star', 'vs', 'white_flower', 'ideograph_advantage', 'secret', 'congratulations',
  'u5408', 'u6e80', 'u5272', 'u7981', 'skull', 'skull_and_crossbones', 'church', 'mosque', 'synagogue', 'kaaba',
  'prayer_beads', 'underage', 'u6307', 'chart', 'u7a7a', 'sa'
]
const categories = categoriesDefault.filter(category => !excludedCategories.includes(category.name))
const emojis = emojisDefault
  .filter(emoji => !excludedCategories.includes(emoji.category))
  .filter(
    emoji => !emoji.aliases.some(
      alias => excludedEmojiAliases.includes(alias)
    )
  )

export default {
  props: {
    select: {
      type: Function,
      default: () => {
      }
    }
  },
  components: { OnClickOutside },
  data() {
    return {
      picker: null,
      popup: null
    }
  },
  mounted() {
    this.picker = new VueRenderer(VEmojiPicker, {
      parent: this,
      propsData: {
        class: 'emoji-picker',
        continuousList: true,
        emojisByRow: 7,
        customEmojis: emojis,
        customCategories: categories
      }
    })
    this.picker.ref.$on('select', this.selectEmoji)
    this.popup = tippy('body', {
      appendTo: () => document.body,
      content: this.picker.element,
      showOnCreate: false,
      interactive: true,
      hideOnClick: false,
      trigger: 'manual',
      placement: 'top-end'
    })[0]
  },
  methods: {
    selectEmoji(emoji) {
      this.select(emoji.data)
    },
    toggleEmojiPicker(event) {
      if (!this.popup.state.isVisible) {
        this.popup.show()
      } else {
        this.popup.hide()
      }
      this.popup.setProps({
        getReferenceClientRect: () => event.target.getBoundingClientRect()
      })
    },
    hideEmojiPicker(e) {
      const tippyEl = document.getElementById('EmojiPicker')
      if (tippyEl && !tippyEl.contains(e.target)) {
        this.popup.hide()
      }
    }
  },
  destroyed() {
    this.popup.destroy()
    this.picker.destroy()
  }
}
</script>

<style lang="scss" scoped>

$emojiHeight: 33px;
.emoji-button {
  width: $emojiHeight;
  height: $emojiHeight;
  border: 0;
  cursor: pointer;
  background-color: transparent;
}
</style>
